import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AbilityGuard } from './core/guards/ability.guard';
import { AuthGuard } from './core/guards/auth.guard';
import { AccessDeniedComponent } from './features/access-denied/access-denied.component';
import { AccessErrorComponent } from './features/access-error/access-error.component';
import { AdminComponent } from './features/admin/admin.component';
import { LoginComponent } from './features/login/login.component';
import { ACCESS } from './core/constant/access';

const abilityGuarded = [AuthGuard, AbilityGuard];

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent
  },
  {
    path: 'access-error/:error',
    component: AccessErrorComponent
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: abilityGuarded,
    runGuardsAndResolvers: 'always',
    data: {
      headerTitle: 'Admin',
      backButton: '/home',
      hamburgerMenu: true,
      hamburgerMobileMenu: true,
      homePage: false,
      showBackButton: true,
      abilities: ACCESS.PAGE.ADMIN
    },
  },
  {
    path: 'home',
    loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule),
    canActivate: abilityGuarded,
    runGuardsAndResolvers: 'always',
    data: {
      backButton: '',
      headerTitle: 'Cast Measurements',
      hamburgerMenu: true,
      hamburgerMobileMenu: false,
      homePage: true,
      showBackButton: false,
      abilities: ACCESS.PAGE.ADMIN
    },
  },
  {
    path: 'cast-measurement/:pernr',
    loadChildren: () => import('./features/cast-measurement/cast-measurement.module').then(m => m.CastMeasurementModule),
    canActivate: abilityGuarded,
    runGuardsAndResolvers: 'always',
    data: {
      headerTitle: 'Cast Measurement',
      backButton: '/home',
      hamburgerMenu: true,
      hamburgerMobileMenu: true,
      homePage: false,
      showBackButton: true,
      abilities: [
        ...ACCESS.PAGE.CAST_VIEWER,
        ...ACCESS.PAGE.CAST_EDITOR
      ]
    },
  },
  {
    path: 'cast-measurement',
    loadChildren: () => import('./features/cast-measurement/cast-measurement.module').then(m => m.CastMeasurementModule),
    canActivate: abilityGuarded,
    runGuardsAndResolvers: 'always',
    data: {
      headerTitle: 'Cast Measurement',
      backButton: '/home',
      hamburgerMenu: true,
      hamburgerMobileMenu: true,
      homePage: false,
      showBackButton: true,
      abilities: ACCESS.PAGE.CAST_EDITOR
    },
  },
  {
    path: 'character-measurement/:characterId',
    loadChildren: () => import('./features/character-measurement/character-measurement.module').then(m => m.CharacterMeasurementModule),
    canActivate: abilityGuarded,
    runGuardsAndResolvers: 'always',
    data: {
      headerTitle: 'Character Measurement',
      backButton: '/home',
      hamburgerMenu: true,
      hamburgerMobileMenu: true,
      homePage: false,
      showBackButton: true,
      abilities: [
        ...ACCESS.PAGE.CHARACTER_VIEWER,
        ...ACCESS.PAGE.CHARACTER_EDITOR
      ]
    },
  },
  {
    path: 'character-measurement',
    loadChildren: () => import('./features/character-measurement/character-measurement.module').then(m => m.CharacterMeasurementModule),
    canActivate: abilityGuarded,
    runGuardsAndResolvers: 'always',
    data: {
      headerTitle: 'Cast Measurement',
      backButton: '/home',
      hamburgerMenu: true,
      hamburgerMobileMenu: true,
      homePage: false,
      showBackButton: true,
      abilities: ACCESS.PAGE.CHARACTER_EDITOR
    },
  },
  {
    /* wildcard route using ** as a path should be last in the order */
    path: '**',
    pathMatch: 'full',
    redirectTo: 'home'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
